
import { Component, Prop, Vue } from 'vue-property-decorator';
import { DownloadUrls } from '../config/types';
import Footer from '../components/Footer.vue';
import MobileHeaderSection from './MobileHeaderSection.vue';
import MobileMainSection from './MobileMainSection.vue';
import { isAndroid, isIOS } from '@/utils/tool';

@Component({
  components: { Footer, MobileHeaderSection, MobileMainSection },
})
export default class MobilePage extends Vue {
  @Prop({ required: true }) public downloadUrls!: DownloadUrls;
  @Prop({ default: false }) public hideList!: boolean;
  @Prop({ default: false }) public showAppInfo!: boolean;
  @Prop({ default: false }) public isBaiduDeveloper!: boolean;
  @Prop({ default: true }) public showAddress!: boolean;
  @Prop({ default: '' }) public developerName!: string;

  public handleDownload() {
    if (isIOS()) {
      window.open('https://ff.huiq233.com/down/wxff');
      return;
    }
    const downloadUrls = this.downloadUrls;
    /* tslint:disable */
    const data = OpenInstall.parseUrlParams();
    new OpenInstall({
      appKey: 'faiw5d',
      onready() {
        this.schemeWakeup();
        window.open(downloadUrls.ANDROID[process.env.NODE_ENV]);
      },
    }, data);
    /* tslint:enable */
  }
}
